import { createAsyncThunk } from "@reduxjs/toolkit";

import { TeamMemberStatus } from "@fitness-app/data-models/entities/TeamMember";

import { type AsyncThunkCreator } from "../../..";
import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { TEAM_REDUCER_NAME } from "../types";

type Payload = string;

export const removeTrainerFromTeam = createAsyncThunk<void, Payload, AsyncThunkCreator<string>>(
  `${TEAM_REDUCER_NAME}/removeTrainerFromTeam`,
  async (payload, { rejectWithValue, extra: { db, auth, analytics } }) => {
    const { id } = await getLoggedUser(auth);

    // Nie kasujemy wiersza: profil zostaje przy przepisach, planach i wiadomościach,
    // które ta osoba stworzyła. Dostęp odcina team-service, banując konto w auth
    // w reakcji na tę zmianę statusu (TRE-1731).
    const { data, error } = await db
      .from("team_member")
      .update({
        status: TeamMemberStatus.DELETED,
        disabled: true,
        selectable: false,
        updatedAt: new Date().toISOString(),
      })
      .eq("id", payload)
      .select("id")
      .maybeSingle();

    if (error) {
      return rejectWithValue(error.message);
    }

    // RLS przepuszcza zmianę statusu wyłącznie właścicielowi konta — bez wiersza
    // w odpowiedzi update przeszedł „na sucho" i nikt by tego nie zauważył.
    if (!data) {
      return rejectWithValue("Nie udało się usunąć członka zespołu — brak uprawnień do tego konta.");
    }

    analytics.track("trainer-removed-from-team", { trainerId: id, memberId: payload });
  },
);
